// TODO: Country code is static

export const AccountDetails = (apiData, updatedMail, updatedMobile) => {
  if (!apiData) return [];

  return [
    {
      key: 1,
      id: "mail",
      title: "Email address",
      description:
        "Choose the name that you need to display on the profile card",
      value: updatedMail ? updatedMail : apiData.email || "Not provided",
      status: updatedMail ? null : apiData.email_verified ? "verified" : null,
    },
    {
      key: 2,
      id: "mobile",
      title: "Mobile number",
      description: "Mobile number that you registered for this profile",
      value: updatedMobile
        ? updatedMobile
        : apiData.phone
          ? `${apiData.countrycode ? apiData.countrycode : ""} ${apiData.phone}`
          : "Not provided",
      status: updatedMobile ? null : apiData.phone_status ? "verified" : null,
    },
  ];
};
